import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=ccc58c5e&scoped=true&"
import script from "./choice.vue?vue&type=script&lang=js&"
export * from "./choice.vue?vue&type=script&lang=js&"
import style0 from "./choice.vue?vue&type=style&index=0&id=ccc58c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc58c5e",
  null
  
)

export default component.exports